import router from './router'
import useUserStore from './store'

export default {
  router,
  useUserStore,
}
